var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupeesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.056 27.3329C21.42 27.3329 27.3893 21.3636 27.3893 13.9996C27.3893 6.63559 21.42 0.66626 14.056 0.66626C6.69199 0.66626 0.722656 6.63559 0.722656 13.9996C0.722656 21.3636 6.69199 27.3329 14.056 27.3329ZM16.056 8.66626C16.4933 9.24759 16.8067 9.92759 16.956 10.6663H19.3893V12.6663H16.956C16.7252 13.7955 16.1115 14.8104 15.2186 15.5393C14.3258 16.2681 13.2086 16.6662 12.056 16.6663H11.8027L16.7627 21.6263L15.3493 23.0396L8.72266 16.4129V14.6663H12.056C12.6765 14.6664 13.2819 14.4742 13.7886 14.116C14.2953 13.7578 14.6785 13.2513 14.8853 12.6663H8.72266V10.6663H14.8853C14.6783 10.0813 14.2951 9.57492 13.7884 9.21675C13.2817 8.85859 12.6765 8.66627 12.056 8.66626H8.72266V6.66626H19.3893V8.66626H16.056Z",
    fill: "#228BE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesIcon);
export default __webpack_public_path__ + "static/media/rupees_icon.8931dd859acc0a06596a0da46d614a91.svg";
export { ForwardRef as ReactComponent };